import { useStaticQuery, graphql } from "gatsby"
import { Link } from "@StarberryUtils";
import React, { useState, useEffect } from "react"
import HTMLReactParser from 'html-react-parser';
import { Button, Form, Container, Row, Col, Fade } from 'react-bootstrap';
import Calculator from "./Calculator";
import MortgageCalc from '../../Calculators/mortgagecalc/';
import StampdutyCalc from '../../Calculators/stampdutycalc/';
import PropertyDetailsMap from '../../map/property-details-map';
import AreaGuid from '../../ProductDetails/AreaGuid/AreaGuid'
import EnquiryForm from "../../Forms/enquiry-form";
import ModalTiny from "react-bootstrap/Modal"
import _ from "lodash";
import ReactMarkdown from "react-markdown";
import $ from "jquery"
import { isMobile, isTablet } from "react-device-detect";

import { inViewOptions, containerVariants } from '../../Utils/animations';
import { motion } from "framer-motion";
import { InView } from "react-intersection-observer";

// Style
import './FeatureDescription.scss';

const MotionContainer = motion(Container)

const Child = React.memo((props) => {
  return (<PropertyDetailsMap lat={props.data.latitude} log={props.data.longitude} />);
});

const FeatureDescription = (props) => {

  const areaGuide = useStaticQuery(graphql`
  query areaGuideQuery{
    glstrapi { 
      areaGuides {
          Area_Title
          Area_Sub_Title
          Embed_Video_URL
          URL
          Postcode
          Tile_Image {
            alternativeText
            url
          }
          Modules_Area_Guides {
            ... on GLSTRAPI_ComponentModulesIntro {
              id
              Intro_Content
            }
          }
      } 
    }
}
`)
  const areas = areaGuide.glstrapi?.areaGuides;

  const [ReadMoreText, ReadMoreLess] = useState(false);
  const [calc, setCalc] = useState(0);
  const [modalEnquiryFormOpen, setEnquiryFormOpen] = React.useState(false);

  const handleClick = () => {
    if (ReadMoreText) {
      let offSet = isMobile ? 90 : isTablet ? 130 : 160
      console.log("offSet >>",offSet);
      $("html, body").animate({
        scrollTop:
          $(`.description-content`)?.offset()?.top - offSet,
      })
    }
  }

  const reactMarkdown = desc => {
    let text = desc && desc.replace(/<br\s*\/?>/gi, '')
    let maxLength = 700
    if (text !== "") {
      return (
        <>
          {!ReadMoreText && text.length > maxLength ? (
            <ReactMarkdown children={text.substr(0, maxLength) + "......."} />
          ) : (
            <ReactMarkdown children={text} />
          )}
        </>
      )
    }
  }

  const ReadMore = () => {
    ReadMoreLess(!ReadMoreText)
    handleClick()
  }
  const closeEnquiryFormModal = () => {
    setEnquiryFormOpen(false);
  }

  var areaGuideDetails = _.find(areas, function (o) {
    var match = false;
    if (props.data?.address?.postcode) {
      var trimmedVal = _.trim(props.data.address.postcode).substring(0, 2);
      if (o.Postcode == trimmedVal) {
        match = true;
      }
    }
    return match;
  });

  const Description =
    props?.data?.description && props?.data?.long_description
      ? props.data.description.concat(" ", `\n\n${props.data.long_description}`)
      : props?.data?.description !== "" && props?.data?.long_description === ""
      ? props.data.description
      : props?.data?.description === "" && props?.data?.long_description !== ""
      ? props.data.long_description
      : ""

  var desc_bg = Description > 700 ? '' : 'description-content-show';

  return (
    <React.Fragment>
      {props.data &&
        <div className="feature-description">
          <InView {...inViewOptions}>
            {({ ref, inView }) => (
              <MotionContainer
                className="feature-content"
                ref={ref}
                initial="hidden"
                animate={inView ? "visible" : "hidden"}
                variants={containerVariants}
              >
                <Row>
                  <Col lg={props.data.accomadation_summary ? 7 : 12}>

                    <div className="feature-section" id="feature-description">
                      {
                        props.data.introtext &&
                        <p className=" highlight-text"> {HTMLReactParser(props.data.introtext.replace(/<br\s*\/?>/gi, ''))}</p>
                      }

                      {Description &&
                        <div className={`description-content ${desc_bg} ${ReadMoreText ? "description-content-show" : ""}`}>
                          <span className="description-title">KEY FEATURES &amp; DESCRIPTION</span>
                          {Description && <p>{reactMarkdown(Description)}</p>}
                          {
                            Description.replace(/<br\s*\/?>/gi, '').length > 700 && (
                              <Button variant="primary" className={`btn read-more`} onClick={ReadMore}>{ReadMoreText ? " Read Less" : " Read More"}</Button>
                            )
                          }
                        </div>
                      }

                      {props.data.search_type == "sales" &&
                        <div className={`link-btn-row`}>
                          <a href="/mortgages/calculator/">
                            <span className="icon-box" ><i className="icon-home"></i></span>
                            <span className="link-text"> Mortgage Calculator</span>
                          </a>

                          <a href="javascript:void(0)" className={calc === 2 ? "actv" : ''} onClick={() => { setCalc(2) }}>
                            <span className="icon-box"><i className="icon-setting"></i></span>
                            <span className="link-text">Stamp Duty Calculator</span>
                          </a>
                        </div>
                      }


                      {
                        !props.data.long_description &&

                        <div className="calculator-form">
                          {(calc === 1) &&
                            <Row>
                              <Col lg={12}>
                                <MortgageCalc propertyPrice={props.data.price} loadDuration={25} />
                                <div className="mortgages-btn">
                                  <Button onClick={() => { setEnquiryFormOpen(true) }} className="btn btn-primary">Request a mortgage call back<i className="icon-arrow"></i></Button>
                                </div>
                              </Col>
                            </Row>

                          }
                          {calc === 2 &&
                            <Row>
                              <Col lg={12}>
                                <StampdutyCalc propertyValue={props.data.price} loadDuration={25} />
                              </Col>
                            </Row>
                          }
                        </div>
                      }
                    </div>

                  </Col>
                  {
                    props.data.accomadation_summary &&
                    <Col lg={5} xl={4} className="d-none d-lg-block ml-auto">

                      <div className="feature-point">
                        {
                          (typeof props.data.accomadation_summary == "object") ?
                            <ul>
                              {props.data.accomadation_summary.map((data, i) => {
                                if (data) {
                                  return (<li key={i}>{data}</li>)
                                } else {
                                  return null;
                                }

                              })
                              }
                            </ul>
                            :
                            HTMLReactParser(props.data.accomadation_summary.replace(/<br\s*\/?>/gi, ''))
                        }
                      </div>
                    </Col>
                  }



                </Row>
                {
                  props.data.long_description &&

                  <div className="calculator-form">
                    {calc === 1 &&
                      <Row>
                        <Col lg={10}>
                          <MortgageCalc propertyPrice={props.data.price} loadDuration={10} />
                          <div className="mortgages-btn">
                            <Button onClick={() => { setEnquiryFormOpen(true) }} className="btn btn-primary">Request a mortgage call back<i className="icon-arrow"></i></Button>
                          </div>
                        </Col>
                      </Row>

                    }
                    {calc === 2 &&
                      <Row>
                        <Col lg={10}>
                          <StampdutyCalc propertyValue={props.data.price} loadDuration={10} />
                        </Col>
                      </Row>
                    }
                  </div>
                }




              </MotionContainer>
            )}
          </InView>
          {(props.data.latitude != 0 && props.data.longitude != 0) &&
            <InView {...inViewOptions}>
              {({ ref, inView }) => (
                <motion.div
                  ref={ref}
                  initial="hidden"
                  animate={inView ? "visible" : "hidden"}
                  variants={containerVariants}
                >
                  <Child {...props} />
                </motion.div>
              )}
            </InView>
          }
        </div>
      }
      {areaGuideDetails &&
        <AreaGuid {...areaGuideDetails} />
      }
      <ModalTiny size="lg" show={modalEnquiryFormOpen} onHide={closeEnquiryFormModal} className="modal-form">
        <ModalTiny.Header closeButton className="contact-close-btn">
          <ModalTiny.Title className="w-100"><h2 className="text-center mb-0 text-uppercase">Request a mortgage call back</h2></ModalTiny.Title>
        </ModalTiny.Header>
        <ModalTiny.Body className="event-section"><EnquiryForm title="Request a mortgage call back" /></ModalTiny.Body>
      </ModalTiny>
    </React.Fragment >

  )
}



export default FeatureDescription